import { cn } from '@savvy-kit/lib/utils';
import { isNil } from 'es-toolkit';

import type { NumberCellContentProps } from '../../types/cell-types';

export function NumberCellContent({ value, description, className }: NumberCellContentProps) {
  return (
    <div data-cell-type="number" className={cn('flex flex-col gap-0.5 items-end', className)}>
      <span className="text-sm text-dark tabular-nums">{value}</span>
      {!isNil(description) && <span className="text-xs text-secondary">{description}</span>}
    </div>
  );
}
